import React from 'react'
import { BiSolidCameraMovie } from "react-icons/bi";
import { MdTimer } from "react-icons/md";
import { WiStars } from "react-icons/wi";

function About() {
  return (
    <div className='flex max-w-[1200px] flex-col md:flex-row mx-auto items-center justify-center mt-[200px] md:space-x-6 text-white' id='About'>
      <div className='max-w-[500px] text-center md:text-left mb-8 md:mb-0' 
              data-aos="fade-up" 
              data-aos-duration="2000" 
              data-aos-delay="1000" 
      >
        <p className='text-[#C0392B] text-xl border-2 border-[#C0392B] rounded-3xl p-2 flex justify-center items-center shadow-xl md:shadow-none md:w-[140px]'>About Us</p>
        <p className='text-4xl md:text-5xl mt-2'>Why Hire Us For Your Next <span className='text-[#C0392B]'>Project ?</span></p>
        <p className='mt-2 text-sm md:text-lg leading-7 gap-5'>We Are A Freelancer team for Video Editing and Thumbnail design</p>
        <a href="#Contact"><button className='mt-3 px-4 py-2 text-white bg-[#C0392B] rounded-lg text-xl hover:text-[#C0392B] hover:border hover:border-[#C0392B] hover:bg-white'>Contact Us</button></a>
      </div>
      <div className="w-full max-w-[800px] p-4"
                    data-aos="fade-up" 
                    data-aos-duration="2000" 
                    data-aos-delay="1000"
      >
        <div className="grid md:grid-cols-2 gap-4">
          {/* First row */}
          <div className="p-5 border  rounded-lg border-[#C0392B] shadow-[#C0392B] shadow-lg">
            <BiSolidCameraMovie className='text-[#C0392B] text-3xl' />
            <p className='mt-2 text-xl font-bold '>Professional Quality</p>
            <p className='mt-2'>High-quality video edits and stunning thumbnails that captivate and engage.</p>
          </div>
          <div className="hidden md:flex p-2"></div>

          {/* Second row */}
          <div className="hidden md:flex p-2"></div>
          <div className="p-5 rounded-lg shadow-lg border-[#C0392B] shadow-[#C0392B]">
            <MdTimer className='text-[#C0392B] text-3xl' />
            <p className='mt-2 text-xl font-bold'>Fast Turnaround</p>
            <p className='mt-2'>Quick and efficient project completion without compromising quality.</p>
          </div>
          {/* Third row */}
          <div className="p-5 rounded-lg shadow-lg border-[#C0392B] shadow-[#C0392B]">
            <WiStars className='text-[#C0392B] text-3xl' />
            <p className='mt-2 text-xl font-bold'>Customized Solutions</p>
            <p className='mt-2'>Tailored services to fit your specific needs and brand vision.</p>
          </div>
          <div className="hidden md:flex p-2"></div>
        </div>
      </div>
    </div>
  );
}

export default About;
